import AddressDetails from '../../model/AddressDetails';
import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => AddressDetails({});

const details = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.ADDRESS_DETAILS:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
};

export default details;
